module.exports = __webpack_public_path__ + "components/flag/static/square/gm-e3f96ac7062a7e924987c4c3e27adde3.svg";